import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { SkillCatalogOptions } from '~/shared/data-contract/skill';

import { useApplicationFetchers } from '../../fetchers/use-application-fetchers';
import { jobArchitectureKeys } from './query-keys';

export const useSkillCatalogOptions = (): UseQueryResult<SkillCatalogOptions, Error> => {
    const { fetchSkillCatalogOptions } = useApplicationFetchers();

    return useQuery({
        queryFn: async () => {
            const result = await fetchSkillCatalogOptions();

            if (result.isOk === true) {
                return result.value;
            }

            throw result.error;
        },
        queryKey: jobArchitectureKeys.skillCatalogOptions(),
        staleTime: 30_000,
        throwOnError: false,
    });
};
